import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/inspace.webp';
import screenshot_target from '../../../images/letterfunnel/martijnapeldoorn.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Martijn Apeldoorn"
      firstname="Martijn"
      companyname="InSpace"
      competition="Traffic Builders en OrangeValley"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/martijnapeldoorn.js